var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIntegrateConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "283px",
    height: "161px",
    viewBox: "0 0 283 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StaFihub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2-Copy",
    transform: "translate(-870.000000, -2495.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(870.000000, 2495.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,152.025055 C14.6023642,90.1785199 35.240135,50.6981482 61.9133126,33.5839395 C88.5864901,16.4697309 116.566011,14.4181261 145.851877,27.4291249 C163.607121,38.9237033 174.831972,47.9260991 179.526429,54.4363123 C192.137624,71.925355 192.261865,97.2871599 192.261865,100.844666 C192.261865,106.38857 176.791869,106.38857 145.851877,100.844666 C150.832308,89.276848 149.472403,79.8515279 141.772159,72.5687061 C130.221794,61.6444733 107.03504,53.0669108 88.1010057,65.1751877 C62.9996325,81.2274657 46.3565492,112.867503 38.1717557,160.095299 L0,152.025055 Z",
    id: "Rectangle-16",
    fill: "#6758FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2876698,133.025055 C103.890034,71.1785199 124.527805,31.6981482 151.200982,14.5839395 C177.87416,-2.53026907 205.853681,-4.58187394 235.139546,8.42912493 C252.894791,19.9237033 264.119642,28.9260991 268.814099,35.4363123 C281.425293,52.925355 282.261865,72.1624554 282.261865,75.7199619 C282.261865,79.9290049 274.110115,83.4242441 257.670021,81.8110371 C254.194134,81.4699609 248.130778,79.9331095 239.479952,77.2004831 C241.56678,68.7287869 238.760072,60.8515279 231.059829,53.5687061 C219.509463,42.6444733 196.322709,34.0669108 177.388675,46.1751877 C152.287302,62.2274657 135.644219,93.8675029 127.459425,141.095299 L89.2876698,133.025055 Z",
    id: "Rectangle-16",
    fill: "#FE7EA7",
    transform: "translate(185.774768, 70.547650) scale(-1, -1) translate(-185.774768, -70.547650) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegrateConnect);
export default __webpack_public_path__ + "static/media/icon_integrate_connect.182519bad67fa20b8aa39b769a2505fc.svg";
export { ForwardRef as ReactComponent };